export const URLS = {
    // BASE_URL: "http://192.168.100.30:8080/api/",
    // BASE_URL: "http://192.168.100.58:8000/api/",
    // BASE_URL: "http://127.0.0.1:8000/api/",
    BASE_URL: "https://rullier.api.ova-consulting.fr/api/",  
    //BASE_URL: "https://test.ovasourcing.ova-consulting.fr/api/",
     //CLIENT_ID: "YOL6YE1L1JJbuq8AtyX6iLeVSvmGFzWRS45Dr4u6",
    //CLIENT_ID: "0En4s1emUqHjhij9P5cHFFg7JbLQLdWKUXef0Xhl",
    PRODUCT_URL: "https://rullier-preprod.ova-consulting.fr/",
    
    AUTHS: {  
      // LOGIN: "auth/mlogin/",
      LOGIN: "auth/magento/oauth/",
      // REFRESH: "token/refresh/",
      REFRESH: "api/token/refresh/",
      LOGOUT: "auth/logout/",
      google: "auth/google/",
      REGISTRATION: "accounts/registration/",
      MANAGER_REGISTRATION: "accounts/staff/registration/",
      VERIFY_EMAIL: (key) => `accounts/accounts/confirm-email/${key}/`,
      VERIFY_ACCOUNT: (id) => `/users/verify/${id}/`,
      resetPassword: "accounts/password-reset/",
      resetPasswordAdmin: "accounts/password/admin-reset/",
      me: "users/me/",
      PASSWORD: {
        reset: "auth/password/reset/",
        confirm: "auth/password/reset/confirm/",
      },
      VERIFY: {
        email: "/accounts/email/verification/",
        resend: "/user/accounts/resend-email/",
      }
    },
  
    // Creating a project
    PROJECT:{
      createProject: "/project/",
      details: (id) => `/project/${id}/`,
      getSteps: 'project/step/',
      createStep: '/project/step/',
      deleteStep: (id) => `/project/step/${id}/`,
      updateStep: (id) => `/project/step/${id}/`,
      createContent: 'project/content'
    },
  
    PRODUCT:{
      getProduct: (query, page) => `product/?search=${query}&page${page}`,
      getProductById: (id) => `product/${id}/`,
      // Essayer différentes variantes d'endpoints
      getProductMagento: (id) => `magento/product/${id}/`,
      getProductCatalog: (id) => `catalog/product/${id}/`,
      getProducts: () => `products/`,
      getProductsById: (id) => `products/${id}/`,
      getAllProducts: () => `product/` // Récupérer tous les produits
    },
    MEDIA: {
      productImage: (imageUrl) => `media/catalog/product/${imageUrl}/`
    },
    QUOTE: {
      create: () => `quote/`
    }
  
  
  }